// Mock data for testing the Activities UI without Intervals.icu API
export const mockWorkoutData = [
  {
    id: "12345",
    date: "2025-06-05",
    type: "Run",
    name: "Morning Easy Run",
    duration: 2400, // 40 minutes
    distance: 8000, // 8km
    avgPower: null,
    avgHR: 145,
    tss: 85,
    feeling: 5,
    description: "Easy pace run through the park. Felt good, legs were fresh."
  },
  {
    id: "12346", 
    date: "2025-06-04",
    type: "Bike",
    name: "Interval Training",
    duration: 3600, // 60 minutes
    distance: 25000, // 25km
    avgPower: 250,
    avgHR: 160,
    tss: 125,
    feeling: 7,
    description: "5x5min @ FTP with 3min recovery. Good power numbers."
  },
  {
    id: "12347",
    date: "2025-06-03", 
    type: "Swim",
    name: "Technique Session",
    duration: 1800, // 30 minutes
    distance: 1500, // 1.5km
    avgPower: null,
    avgHR: 135,
    tss: 45,
    feeling: 6,
    description: "Drill focused session. Worked on catch and rotation."
  },
  {
    id: "12348",
    date: "2025-06-02",
    type: "Run", 
    name: "Long Run",
    duration: 5400, // 90 minutes
    distance: 15000, // 15km
    avgPower: null,
    avgHR: 140,
    tss: 110,
    feeling: 4,
    description: "Steady long run. Last 30min felt tough but pushed through."
  },
  {
    id: "12349",
    date: "2025-06-01",
    type: "Brick",
    name: "Bike + Run Brick",
    duration: 4200, // 70 minutes
    distance: 30000, // 30km total
    avgPower: 220,
    avgHR: 155,
    tss: 95,
    feeling: 6,
    description: "45min bike followed by 25min run. Good transition practice."
  },
  {
    id: "12350",
    date: "2025-05-31",
    type: "Strength",
    name: "Upper Body Strength",
    duration: 2700, // 45 minutes
    distance: null,
    avgPower: null,
    avgHR: 120,
    tss: 55,
    feeling: 7,
    description: "Focus on core and shoulders. 3 sets of 12 reps each exercise."
  },
  {
    id: "12351",
    date: "2025-05-30",
    type: "Swim",
    name: "Endurance Swim",
    duration: 2700, // 45 minutes
    distance: 2000, // 2km
    avgPower: null,
    avgHR: 138,
    tss: 65,
    feeling: 5,
    description: "Continuous swimming. Maintained steady pace throughout."
  },
  {
    id: "12352", 
    date: "2025-05-29",
    type: "Run",
    name: "Recovery Run",
    duration: 1800, // 30 minutes
    distance: 5000, // 5km
    avgPower: null,
    avgHR: 125,
    tss: 35,
    feeling: 8,
    description: "Very easy recovery pace. Legs felt fresh."
  },
  {
    id: "12353",
    date: "2025-05-28",
    type: "Bike",
    name: "Endurance Ride", 
    duration: 7200, // 120 minutes
    distance: 60000, // 60km
    avgPower: 200,
    avgHR: 145,
    tss: 155,
    feeling: 4,
    description: "Long steady ride. Practiced nutrition strategy."
  },
  {
    id: "12354",
    date: "2025-05-27",
    type: "Rest",
    name: "Rest Day",
    duration: null,
    distance: null,
    avgPower: null,
    avgHR: null,
    tss: null,
    feeling: 9,
    description: "Complete rest day. Focused on recovery and stretching."
  }
];

export const mockPlannedWorkouts = [
  {
    id: "plan_001",
    date: "2025-06-07",
    type: "Run", 
    name: "Tempo Run",
    description: "20min warm-up, 30min @ tempo pace, 10min cool-down",
    planned_duration: 3600,
    planned_distance: 12000,
    category: "Run"
  },
  {
    id: "plan_002", 
    date: "2025-06-08",
    type: "Swim",
    name: "Sprint Sets",
    description: "400m warm-up, 8x50m sprints, 400m cool-down", 
    planned_duration: 2400,
    planned_distance: 1200,
    category: "Swim"
  }
];

// Return mock data with dates shifted to be relative to today
export const getMockData = () => {
  const today = new Date();
  const daysAgo = (n) => {
    const d = new Date(today);
    d.setDate(d.getDate() - n);
    return d.toISOString().split('T')[0];
  };
  const daysAhead = (n) => {
    const d = new Date(today);
    d.setDate(d.getDate() + n);
    return d.toISOString().split('T')[0];
  };

  const offsets = [0, 1, 2, 4, 5, 6, 7, 8, 9, 10];
  const recentWorkouts = mockWorkoutData.map((w, i) => ({ ...w, date: daysAgo(offsets[i] ?? i) }));
  const plannedWorkouts = mockPlannedWorkouts.map((w, i) => ({ ...w, date: daysAhead(i + 2) }));

  return { recentWorkouts, plannedWorkouts, isLoading: false };
};
